import { CircleAlert } from 'lucide-react'

import { Progress } from '@/components/ui/progress'
import { User } from '@/payload-types'

import { getUserCompletion } from './GuidedIntro/components/profile/profileStepCompletion'

export const ProfileProgress = ({ user }: { user: User }) => {
  const totalUserFieldsComplete = getUserCompletion(user)

  return (
    <div className="flex w-full flex-col items-center gap-2 text-center">
      <p className="flex items-center gap-1.5 font-family-body text-sm text-muted-foreground">
        <CircleAlert className="size-3.5 text-accent-4" />
        {totalUserFieldsComplete.completePercentage}% of your profile is complete
      </p>
      <Progress value={totalUserFieldsComplete.completePercentage} className="w-full" />
    </div>
  )
}
